import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Link from '@mui/material/Link'
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { userLogout } from "../../reducers/auth";

import { fetchTermsandConditions, fetchTCStatus, updateTCStatus } from "../../reducers/terms_and_conditions";
import { Box, Skeleton, Typography } from "@mui/material";

const TermsAndConditions = (props) => {
  const { user: currentUser, behalfOfUser: behalfOfUser } = useSelector((state) => state.auth);
  const [ open, setOpen ] = useState(false)
  const location = useLocation()
  const [ openWarning, setOpenWarning ] = useState(false)
  const [ isLoaded, setisLoaded ] = useState(false)

  const TCVIstatus = useSelector(state => state.termsandconditions.status)
  const viewInstance = useSelector(state => state.termsandconditions.entities)
  const TCSUserStatus = useSelector(state => state.termsandconditions.userstatus)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  
  useEffect(() => {
    if(TCVIstatus === "idle" && currentUser?.AuthToken && location.pathname !== '/pwreset' ){
      dispatch(fetchTermsandConditions({ authToken: currentUser.AuthToken }))
      
    }
  })

  useEffect(() => {
    if(!isLoaded){
      dispatch(fetchTCStatus({ authToken: currentUser.AuthToken }))
      setisLoaded(true)
    }
  })

  useEffect(() => {
    if(TCSUserStatus === "0" && location.pathname !== '/pwreset' && !behalfOfUser?.AuthToken){
      setOpen(true)
    } 
  }, [TCSUserStatus])

  useEffect(() => {
    
  }, [viewInstance])
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgree = () => {
    dispatch(updateTCStatus({ authToken: currentUser.AuthToken, status: 1}))
      .then(() => {
        setOpen(false)
      })
  }

  const handleDisagree = () => {
    setOpenWarning(true)
  }

  const handleAcceptDisagree = () => {
    dispatch(updateTCStatus({ authToken: currentUser.AuthToken, status: 0}))
      .then(() => {
        dispatch(userLogout(currentUser))
        setOpenWarning(false)
        setOpen(false)
        navigate('/logout')
      })
  }

  const handleCancelDisagree = () => {
    setOpenWarning(false)
  }
  if(viewInstance.TsAndCsPage){
    return (
      <Box>
       
          <Typography variant="body2" sx={{ "&:hover": { textDecoration:"underline",cursor: "pointer" }}} onClick={handleClickOpen}> 
          {viewInstance.TsAndCsPage.TsAndCsFrame.TsAndCsHeaderSecondLine} 
          </Typography>
 
        <Dialog open={open} disableBackdropClick>
          <DialogTitle>{viewInstance.TsAndCsPage.TsAndCsFrame.TsAndCsHeaderSecondLine}</DialogTitle>
          <DialogContent>
            <DialogContentText style={{wordWrap:"break-word"}} dangerouslySetInnerHTML={{__html: viewInstance.TsAndCsPage.TsAndCsFrame.TsAndCsSQL[0].StandardContent}}>
            </DialogContentText>
            
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAgree} variant="contained">{viewInstance.TsAndCsPage.TsAndCsFrame.TsAndCsAcceptButton}</Button>
            <Button onClick={handleDisagree} variant="outlined">{viewInstance.TsAndCsPage.TsAndCsFrame.TsAndCsRejectButton}</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openWarning} disableBackdropClick="true">
          <DialogTitle>{viewInstance.TsAndCsPage.TsAndCsRejectCfmFrame.TsAndCsRejectCfmHeader}</DialogTitle>
          <DialogContent>
            <DialogContentText dangerouslySetInnerHTML={{__html:viewInstance.TsAndCsPage.TsAndCsRejectCfmFrame.TsAndCsRejectCmfRelatedText}}>
            </DialogContentText>
            
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleAcceptDisagree()} variant="contained">{viewInstance.TsAndCsPage.TsAndCsRejectCfmFrame.TsAndCsRejectCfmYesButton}</Button>
            <Button onClick={() => handleCancelDisagree()} variant="outlined">{viewInstance.TsAndCsPage.TsAndCsRejectCfmFrame.TsAndCsRejectCfmCancelButton}</Button>
          </DialogActions>
        </Dialog>
      </Box> 
    )
  } else {
    return (
      <Box>
       
       <Link variant="caption" underline="hover" >
          <Typography variant="body2"> Terms and Conditions </Typography>
        </Link>
        <Dialog open={open}  disableBackdropClick>
          <DialogTitle>
            <Skeleton variant="text" width={150} />
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{wordWrap:"break-word"}}>
              <Skeleton variant="rounded" width={200} height={300}/>
            </DialogContentText>

          </DialogContent>
        </Dialog>
        
      </Box>
    )
  }
  
};

export default TermsAndConditions;